import React, { Component } from 'react'

class Breadcrumbs extends Component {
  render () {
    return (
      <nav>
        <ol className='breadcrumb'>
          {this.props.links && this.props.links.map(link => <li key={link.text} className={link.active ? 'active' : ''}>{link.active ? link.text : <a href={link.link}>{link.text}</a>}</li>)}
        </ol>
      </nav>
    )
  }
}
export default Breadcrumbs



// WEBPACK FOOTER //
// ./src/components/basic/displays/Breadcrumbs.js